module.exports = __webpack_public_path__ + "178299659db3e8de587b37ea50a80516.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/arrow.png
// module id = ./app/images/arrow.png
// module chunks = 29